export class HttpError extends Error {
  constructor(public readonly status: number, message?: string) {
    super(message ?? `Request failed (HTTP ${status})`);
    this.name = "HttpError";
  }
}